import React, { useLayoutEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MdFilterAlt } from 'react-icons/md';

import * as S from './styles';
import { color } from 'styles/pallete';
import SimpleInput from 'components/SimpleInput';
import Check from 'components/Buttons/Check';
import { UseTranslationProps } from 'types/UseTranslationProps';
import { getUsers } from 'pages/Users/reqs';
import { UserMondelezProps } from 'types/UserProps';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import useDebounce from 'hooks/useDebounce';
import { FiltersUsersProps } from 'types/FiltersUsersProps';
import { removeSpecialCharacters } from 'utils/functions';

interface FilterUsersProps {
	setListUsers: React.Dispatch<React.SetStateAction<UserMondelezProps[]>>;
	page: number;
	setPage: React.Dispatch<React.SetStateAction<number>>;
	setQtdPages: React.Dispatch<React.SetStateAction<number>>;
	filters: FiltersUsersProps;
	setFilters: React.Dispatch<React.SetStateAction<FiltersUsersProps>>;
	justUsersAllowed: boolean;
	setJustUsersAllowed: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function FilterUsers({
	page,
	setListUsers,
	setQtdPages,
	filters,
	setFilters,
	justUsersAllowed,
	setJustUsersAllowed,
	setPage
}: FilterUsersProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [isFirstRender, setIsFirstRender] = useState(true); // Estado auxiliar para evitar a primeira chamada
	const filtersDebounce = useDebounce(filters, 1000);
	const justUsersAllowedDebounce = useDebounce(justUsersAllowed, 1000);

	useLayoutEffect(() => {
		if (isFirstRender) {
			setIsFirstRender(false); // Atualiza o estado para falso na primeira renderização
			return;
		}

		(async () => {
			setIsOpenLoad(true);
			setMessage('Carregando usuários');
			await getUsers(
				{
					filterByCpf: removeSpecialCharacters(filters.filterByCpf),
					filterByEmail: filters.filterByEmail,
					justUsersAllowed: justUsersAllowed
				},
				page,
				setListUsers,
				setQtdPages,
				handleNotify
			);
			setIsOpenLoad(false);
		})();
	}, [filtersDebounce, justUsersAllowedDebounce]);

	return (
		<S.container>
			<S.box>
				<MdFilterAlt
					style={{ fontSize: '2rem', color: color.interface.lightGray }}
				/>
				<S.title>{t('users.filterUsers.filters')}</S.title>
			</S.box>

			<S.box>
				<SimpleInput
					getValue={(value: string) => {
						setFilters((obj) => ({ ...obj, filterByEmail: value }));
					}}
					initialValue={filters.filterByEmail}
					placeHolder="E-mail"
					withoutLabel
				/>
			</S.box>

			<S.box>
				<Check
					setIsChecked={() => {
						setJustUsersAllowed((value) => !value);
						setPage(1);
					}}
					isChecked={justUsersAllowed}
					text={'Usuarios CMS'}
					colorCheck={color.interface.green2}
				/>
			</S.box>
			<div style={{ display: 'none' }}>
				<S.box>
					<SimpleInput
						getValue={(value: string) => {
							setFilters((obj) => ({ ...obj, filterByCpf: value }));
						}}
						initialValue={filters.filterByCpf}
						placeHolder={t('users.filterUsers.userIdentifications')}
						withoutLabel
					/>
				</S.box>

				<S.box>
					<Check
						setIsChecked={setJustUsersAllowed}
						isChecked={justUsersAllowed}
						text={t('users.filterUsers.justUsersAllowed')}
						colorCheck={color.interface.green2}
					/>
				</S.box>
			</div>
		</S.container>
	);
}
